/**
 * Sampling policy: keep 100% of warn/error (the root-cause signal) and 100% of
 * ordinary info events; only the highest-volume info "heartbeats" are
 * rate-sampled to control Datadog volume. Pure: the caller supplies the random
 * value so this is deterministic and testable.
 */

// NEVER add acquisition/analytics events here (page_view "Page view: …",
// link_click, signup events): the Growth dashboard counts unique visitors and
// campaign conversions from them, so they must ship at 100% regardless of
// LOG_INFO_SAMPLE_RATE. Only pure engineering heartbeats belong in this set.
const HIGH_VOLUME_INFO_EVENTS = new Set([
  "http_request_start",
  "http_request_complete",
  "api_request_start",
  "api_request_complete",
])

export function isHighVolumeInfoEvent(message: string): boolean {
  return HIGH_VOLUME_INFO_EVENTS.has(message)
}

/**
 * @param level        log level ("info" | "warn" | "error" | …)
 * @param message      the event/message name
 * @param infoSampleRate keep-probability [0,1] for high-volume info heartbeats
 * @param rngValue     a random value in [0,1) supplied by the caller
 * @returns true if the log should be emitted
 */
export function shouldSampleLog(
  level: string,
  message: string,
  infoSampleRate: number,
  rngValue: number
): boolean {
  if (level !== "info") return true // warn/error/everything else: always keep
  if (!isHighVolumeInfoEvent(message)) return true // ordinary info: always keep
  return rngValue < infoSampleRate
}
